import ajax from '@/utils/ajax';

export const head = '/web';

// 获取当前活动信息
export const getPullNewInfoApi = (id, isPreview) =>
  ajax(`${head}/v1/pull-new/activity/data?activityId=${id}&isPreview=${isPreview}`, '', 'POST');

// 更新用户参加分享状态
export const pushShareStatusApi = (id) =>
  ajax(`${head}/v1/pull-new/activity/share/picture?activityId=${id}`, '', 'POST');

// 领取奖品接口
export const receivePrizeApi = (data) =>
  ajax(`${head}/v1/pull-new/activity/receive/prize`, data, 'POST');

// 查询我领取的奖品的详情
export const myPrizeInfoApi = (data) =>
  ajax(`${head}/v1/pull-new/activity/prize/${data.activityId}/${data.activityPrizeId}`, '', 'POST');

// 助力页获取活动信息
export const getAssistanceInfoApi = (data) =>
  ajax(
    `${head}/v1/pull-new/activity/assistance/data?activityId=${data.activityId}&encryptionKey=${data.encryptionKey}`,
    '',
    'POST',
  );

// 助力接口
export const assistanceApi = (data) =>
  ajax(
    `${head}/v1/pull-new/activity/assistance?activityId=${data.activityId}&encryptionKey=${data.encryptionKey}`,
    '',
    'GET',
  );

// 新助力接口
export const newAssistanceApi = (data) => {
  return ajax(`${head}/v1/pull-new/activity/v2/assistance`, data, 'POST');
};
// 获取推荐相关接口
export const getRecommentInfoApi = (id) =>
  ajax(`${head}/v1/pull-new/activity/recommend?activityId=${id}`);

// 查看社群详情
export const getCommunityDetails = (id) => ajax(`${head}/v1/community/${id}`);

// /web/
export const getPullNewList = (examSeasonIdList, pageNum, pageSize, sourceFlag = 0) =>
  ajax(
    `${head}/v1/pull-new/activity/pull-new-activity-list?examSeasonIdList=${examSeasonIdList}&pageNum=${pageNum}&pageSize=${pageSize}&sourceFlag=${sourceFlag}`,
  );
